import { HelperShelfMessage, HelperShelfTrigger } from "components/helper_shelf"
import { Checkbox, PillToggle } from "components/ui"
import { bool, func, node, string } from "prop-types"

const HIDDEN = "hidden"
const OPTIONAL = "optional"
const REQUIRED = "required"

const TristateCheckbox = ({
  checkboxValueFormatter = v => v,
  forceRequired = false,
  helperShelfMessage = null,
  htmlFor,
  name,
  onSelect,
  text,
  tooltip = "",
  value,
  wrapperClasses
}) => {
  const checked = value !== HIDDEN

  const handleCheckboxSelect = ({ target: { checked } }) => onSelect(checked ? OPTIONAL : HIDDEN)

  const handlePillToggleClick = e => {
    e.preventDefault()

    const newValue = value === REQUIRED ? OPTIONAL : REQUIRED
    onSelect(htmlFor === "medical" ? OPTIONAL : newValue)
  }

  return (
    <div>
      <div
        css={{
          display: "grid",
          gridTemplateColumns: "minmax(100px, max-content) 1fr",
          columnGap: "16px",
          alignItems: "center"
        }}
      >
        <div className="d-f g-1 ai-c">
          <Checkbox
            checked={checked}
            htmlFor={htmlFor}
            name={name}
            onSelect={handleCheckboxSelect}
            text={text}
            value={checkboxValueFormatter(value)}
            wrapperClasses={wrapperClasses}
          />
          {helperShelfMessage && (
            <HelperShelfTrigger id={htmlFor} type="button" style={{ marginTop: "5px" }} />
          )}
        </div>
        {checked ? (
          <div {...(tooltip.length ? { "data-tooltip": tooltip } : {})}>
            <PillToggle
              clickHandler={handlePillToggleClick}
              disabled={forceRequired}
              required={value === REQUIRED}
              optionalOnly={htmlFor === "medical"}
            />
          </div>
        ) : (
          <span />
        )}
      </div>
      {helperShelfMessage && (
        <HelperShelfMessage id={htmlFor}>{helperShelfMessage}</HelperShelfMessage>
      )}
    </div>
  )
}

TristateCheckbox.propTypes = {
  checkboxValueFormatter: func,
  forceRequired: bool,
  helperShelfMessage: node,
  htmlFor: string.isRequired,
  name: string.isRequired,
  onSelect: func.isRequired,
  text: string.isRequired,
  tooltip: string,
  value: string.isRequired,
  wrapperClasses: string.isRequired
}

export default TristateCheckbox
